import "bootstrap/js/dist/modal";
import "bootstrap/js/dist/collapse";

import Header from "design-system/resources/html/components/common/header/header";
import NavbarMobile from "design-system/resources/html/components/common/navbar-mobile/navbar-mobile";
import SideBarMenuStikcy from "design-system/resources/html/components/common/sidebar/sidebar";

import Guides from "design-system/resources/html/components/common/guides/guides";
import ResponsiveTable from "design-system/resources/html/components/common/responsive-table/responsive-table";

import RiskWarningBar from "design-system/resources/html/components/common/risk-warning-bar/risk-warning-bar";

import getIdCarouselForAutoSlide from "./carousel";
import getIdCarouselForGlideSlide from './glide';
import addItemSessionStorage from "./addItemSessionStorage";
import mParticleLogEvent from "./mParticleLogEvent";
import ibFormHelperFunc from "./ib-form";

window.onload = function () {
  Header();
  NavbarMobile();
  getIdCarouselForAutoSlide();
  getIdCarouselForGlideSlide();
  Guides();
  ResponsiveTable();
  RiskWarningBar();
  mParticleLogEvent();
  addItemSessionStorage();
  SideBarMenuStikcy();
};

(function (Drupal) {
  Drupal.behaviors.ib_form = {
    attach: function(context, settings) {
      ibFormHelperFunc();
    }
  };
})(Drupal);
